import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
// import { audioScoreCard } from '../../assets/data/audioScorecard'
// import { chatScoreCard } from '../../assets/data/chatScorecard'
import { ScoreCardContext } from '../../store/scorecard-context'
import { ScoreCardData } from '../../types/interface'
import { getCookie } from '../../utils/common'
import Questions from './Questions'
import styles from './ScoreCard.module.css'
import { isAllQuestionAnswered } from './common'
import { AuthContext } from '../../store/auth-context'
import { scorecardsAPI } from '../../services/api/scorecards'


const ScoreCard = (props: any) => {

    const scorecardCtx = useContext(ScoreCardContext)
    const authCtx = useContext(AuthContext)
    const isAdmin = authCtx.userRole === 'admin'
    const isQA = authCtx.userRole === 'qa'
    const isManager = authCtx.userRole === 'manager'

    const [isContextLoaded, setIsContextLoaded] = useState<boolean>(false)
    const [sectionScore, setSectionScores] = useState<{[key: string]: Array<number>}>({})

    const [isSaving, setIsSaving] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isSavingError, setIsSavingError] = useState(false)
    const [isSubmittingError, setIsSubmittingError] = useState(false)
    const [isSavingSuccess, setIsSavingSuccess] = useState(false)
    const [isSubmittingSuccess, setIsSubmittingSuccess] = useState(false)
    
    
    useEffect(() => {
        // If its only customer conversation then no need to call the scorecard which gives the latest scorecard details
        if(isAdmin || isQA || isManager) {
            getScoreCard()
        }
    }, [])

    useEffect(() => {
        if(scorecardCtx?.scores?.sections && scorecardCtx?.scores?.sections.length) {
            setIsContextLoaded(true)
        }
    }, [scorecardCtx.scores])

    // Get Scorecard
    const getScoreCard = () => {
        let tenantSlug = getCookie('current_tenant')
        let API: any = ''
        API = scorecardsAPI(tenantSlug)?.getSingle?.(props.id)
        // if(reviewUUID) {
        //     API = scorecardsAPI(tenantSlug)?.getSingle?.(id)
        // } else {
        //     // This should be called only when user clicks the Review button and also when there is no uuid
        //     const data = {
        //         conversation_id: id,
        //         call_type: type.toLowerCase()
        //     }
        //     API = scorecardsAPI(tenantSlug).post?.(data)
        // }
        API?.then((response: any) => {
            // if(!reviewUUID) {
            //     setReviewUUID(response.uuid)
            // }
            scorecardCtx.updateScores(response)
        })
        .catch((err: any) => {
            if (err.response) {
                console.log(err.response)
            } else if (err.request) {
                console.log(err.request)
            } else {
                console.log(err)
            }
        })
    }

    // get total comments are all options selected
    useEffect(() => {
        // if(scorecardCtx.reviewedScore) {
        //     let totalComments: number = 0
        //     scorecardCtx.scores && scorecardCtx.scores.map(({questions}: ScoreCardData, index: number) => {
        //         let sectionCommentsCount: number = 0
        //         questions.map((question) => {
        //             if(question.comment.text) {
        //                 sectionCommentsCount++ 
        //             }
        //         })
        //         totalComments += sectionCommentsCount
        //     })
        //     scorecardCtx.updateTotalComments(totalComments)
        // }
    }, [scorecardCtx.scores, scorecardCtx.reviewedScore])

    useEffect(() => {
        if(scorecardCtx.scores.is_published) {
            // scorecardCtx.updateReviewedScore(true)
        } else {
            // if(Object.keys(scorecardCtx.scores).length) {
            //     let isAllAnswered = isAllQuestionAnswered(scorecardCtx.scores)
            //     scorecardCtx.updateReviewedScore(isAllAnswered)
            // }
        }
    }, [scorecardCtx.scores])

    // isSubmit - when they click on direct submit
    // Submit Review is patch request hence we call saveReview first and then submitReview for direclty clicking on Submit button
    // const saveReview = (isSubmit: boolean = false) => {
    //     setIsSavingError(false)
    //     setIsSavingSuccess(false)
    //     if(!isSubmit) {
    //         setIsSaving(true)
    //     }
    //     let tenantSlug = getCookie('current_tenant')
    //     const data = {
    //         sections: scorecardCtx.scores.sections
    //     }
    //     scorecardsAPI(tenantSlug)?.put?.(reviewUUID, data)
    //     .then(response => {
    //         scorecardCtx.updateScores(response)
    //         if(!isSubmit) {
    //             setIsSavingSuccess(true)
    //             setIsSaving(false)
    //             getReviewStats()
    //             setTimeout(() => {
    //                 setIsSavingSuccess(false)
    //             }, 3000)
    //         }
    //         if(isSubmit) {
    //             submitReview()
    //         }
    //     })
    //     .catch((err: any) => {
    //         setIsSavingError(true)
    //         setIsSaving(false)
    //         setTimeout(() => {
    //             setIsSavingError(false)
    //         }, 3000)
    //         if (err.response) {
    //             console.log(err.response)
    //         } else if (err.request) {
    //             console.log(err.request)
    //         } else {
    //             console.log(err)
    //         }
    //     })
    // }

    const submitReview = () => {
        setIsSubmittingError(false)
        setIsSubmittingSuccess(false)
        setIsSubmitting(true)
        let tenantSlug = getCookie('current_tenant')
        const data = scorecardCtx.scores
        scorecardsAPI(tenantSlug)?.put?.(props.id, data)
        .then((response: any) => {
            scorecardCtx.updateScores(response)
            setIsSubmittingSuccess(true)
            setIsSubmitting(false)
            // getReviewStats()
            setTimeout(() => {
                setIsSubmittingSuccess(false)
            }, 3000)
        })
        .catch((err: any) => {
            setIsSubmittingError(true)
            setIsSubmitting(false)
            setTimeout(() => {
                setIsSubmittingError(false)
            }, 3000)
            if (err.response) {
                console.log(err.response)
            } else if (err.request) {
                console.log(err.request)
            } else {
                console.log(err)
            }
        })
        
        window.scrollTo(0, 0)
    }

    return (
        (scorecardCtx?.scores?.ai_analysed || scorecardCtx?.scores?.review_by != 'AI') ?
            <div className={styles.scoreCardContainer}>
                <div className={`d-flex justify-content-between mb-2 ${styles.scoreCardHeader}`}>
                    {
                        isContextLoaded ?
                            <>
                                <h6>{scorecardCtx.activeSection >=0 ? scorecardCtx?.scores?.sections[scorecardCtx.activeSection]?.name : null}</h6> 
                                <div className={styles.submitReviewContainer}>
                                    {
                                        isSaving || isSubmitting ?
                                        <div>
                                            <div className="alert alert-primary d-flex align-items-center fw-bold" role="alert">
                                                <span className="spinner-border spinner-border-sm pe-1 me-2" role="status" aria-hidden="true"></span>{isSaving ? 'Saving...' : 'Submitting...'}
                                            </div>
                                        </div>
                                        :
                                        (
                                            isSavingError || isSubmittingError ?
                                                <div className="alert alert-danger d-flex align-items-center fs-6" role="alert">
                                                    <i className="bi bi-exclamation-triangle pe-1"></i>
                                                    <div>
                                                        Opps Somthing went wrong! Please try again.
                                                    </div>
                                                </div>
                                                :
                                                (
                                                    isSavingSuccess || isSubmittingSuccess ?
                                                        <div>
                                                            
                                                            <div className="alert alert-success d-flex align-items-center fs-6" role="alert">
                                                                <i className="bi bi-check-circle pe-1"></i>
                                                                <div>
                                                                { isSavingSuccess ? 'Saved Successfully!' : 'Submitted Successfully!' }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        <>
                                                            {/* <button type="button" onClick={() => saveReview()} hidden={scorecardCtx.isReviewSubmitted ? true : false} className={`btn btn-primary me-3`}>Save</button> */}
                                                            <button type="button" onClick={() => submitReview()} className={`btn btn-primary ${styles.updateScore}`}>Update Score</button>
                                                        </>
                                                )
                                        )
                                    }
                                </div>
                            </> :
                            null
                    }
                    {/* <div className="d-flex align-items-center">
                        {
                            scorecardCtx.reviewedScore && 
                                <div>
                                    {
                                        scorecardCtx.totalComments > 0 &&
                                        <span className={`${styles.totalCommentsCount} pe-3`}><i className="bi bi-chat-dots fs-6 pe-1"></i>{scorecardCtx.totalComments}</span>
                                    }
                                    {
                                        scorecardCtx.scores.score > 0 && <span className={styles.OverallScore}>Overall Score: {Math.round(scorecardCtx.scores.score)}%</span>
                                    }
                                </div> 
                        }
                    </div> */}
                </div>            
                <div className={styles.scoreCardQuestionsContainer}>
                    {
                        isContextLoaded ?
                            <div className="bg-transparent border-0 mb-3">
                                <div className="p-3">
                                    <ul className="list-unstyled m-0">
                                        <Questions
                                            // score={score}
                                            // sectionUUID={uuid}
                                            id={props.id}
                                            sectionIndex={scorecardCtx.activeSection}
                                            questions={scorecardCtx?.scores?.sections[scorecardCtx.activeSection]?.questions}
                                        />
                                    </ul>
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
            </div> :
            null
    )
}

export default ScoreCard
